import { z } from 'zod';

export const userNetworkSchema = z.object({
  id: z.string(),
  nome: z.string(),
  redePai: z.boolean().optional(),
});

export type UserNetwork = z.infer<typeof userNetworkSchema>;

export const userNetworksResponseSchema = z.array(userNetworkSchema);

export type UserNetworksResponse = z.infer<typeof userNetworksResponseSchema>;
